
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCurrent3 as ObiCurrent3Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-current-3.js';
 
 
 

 
 export const ObiCurrent3 = createComponent({
   react: React,
   tagName: 'obi-current-3',
   elementClass: ObiCurrent3Element,
   events: {
     
   }
  });
 
 